export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10552.a80f6fb0.jpg";